import React, { useState } from "react";
import WebLottiePlayer from "../WebLottiePlayer";
import WebShadowButton from "../WebShadowButton";
import WebAudioPlayer from "../WebAudioPlayer";

interface BreakButton {
  btnIcon: string;
  btnTitle: string;
  btnAudio: string;
  btnLinkTo: string;
}

interface WebBreakModalProps {
  onClose: () => void;
  onConfirm: (_btnLinkTo: string) => void;
  breakData: {
    title: string;
    audio: string;
    buttons: BreakButton[];
  };
  contentBaseUrl?: string;
}

const WebBreakModal: React.FC<WebBreakModalProps> = ({
  onClose,
  onConfirm,
  breakData,
  contentBaseUrl,
}) => {
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>(
    undefined,
  );
  const [audioUrl, setAudioUrl] = useState(breakData.audio);

  const handleTileClick = (index: number) => {
    setSelectedIndex(index);
    setAudioUrl(breakData.buttons[index].btnAudio);
  };

  return (
    <div className="web-break-modal-overlay">
      <div className="web-break-modal-box">
        <div className="web-break-modal-header">
          <span className="web-break-modal-title">{breakData.title}</span>
          <button
            type="button"
            className="web-break-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <div className="web-break-modal-tiles">
          {breakData.buttons.map((btn, idx) => (
            <button
              key={idx}
              type="button"
              className={`web-break-modal-tile${selectedIndex === idx ? " selected" : ""}`}
              onClick={() => handleTileClick(idx)}
            >
              <WebLottiePlayer
                source={btn.btnIcon}
                className="web-break-modal-tile-icon"
                autoPlay={false}
                loop={false}
              />
              <span className="web-break-modal-tile-text">{btn.btnTitle}</span>
            </button>
          ))}
        </div>

        <div className="web-break-modal-confirm-row">
          <WebShadowButton
            title="Okay!"
            disabled={selectedIndex === undefined}
            onPress={() => {
              if (selectedIndex !== undefined) {
                onConfirm(breakData.buttons[selectedIndex].btnLinkTo);
              }
            }}
          />
        </div>

        {audioUrl ? (
          <WebAudioPlayer uri={audioUrl} contentBaseUrl={contentBaseUrl} />
        ) : null}
      </div>
    </div>
  );
};

export default WebBreakModal;
